import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { QuizSubmitResult } from '../../../../models/interfaces/quiz.interface';
import { EnfafButtonComponent } from '../../../../components/enfaf-button/enfaf-button.component';
import { EnfafIconComponent } from '../../../../components/enfaf-icon/enfaf-icon.component';

@Component({
  selector: 'app-quiz-result',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, EnfafButtonComponent, EnfafIconComponent],
  templateUrl: './quiz-result.component.html',
  styleUrl: './quiz-result.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuizResultComponent {
  result = input.required<QuizSubmitResult>();

  /**
   * The self-assessment never blocks the course (ENF-2511): a failed attempt offers to rewatch
   * the class, but the student can always continue to the next one.
   */
  action = output<'next-class' | 'rewatch'>();

  onContinue(): void {
    this.action.emit('next-class');
  }

  onRewatch(): void {
    this.action.emit('rewatch');
  }
}
